import { render, staticRenderFns } from "./modal-modify-treatment.vue?vue&type=template&id=e762ee56&lang=pug"
import script from "./modal-modify-treatment.js?vue&type=script&lang=js&external"
export * from "./modal-modify-treatment.js?vue&type=script&lang=js&external"
import style0 from "./modal-modify-treatment.vue?vue&type=style&index=0&id=e762ee56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports